export default __webpack_public_path__ + "static/media/amiguero-1.0795e549.png";